import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _  from 'lodash';
@Component({
  selector: 'app-onofswitch',
  templateUrl: './onofswitch.component.html',
  styleUrls: ['./onofswitch.component.scss']
})
export class OnofswitchComponent implements OnInit {

  @Input() switchInput:boolean; 
  @Input() customText:string;
  uniqueId:any
  @Output() switchChange: EventEmitter<any> = new EventEmitter();
  onText : string = 'ON';
  offText: string = 'OFF';
  status:boolean = false;
  currentText:string;
  isEnglishText:boolean = true; 

  constructor(private translate: TranslateService) {
    if(this.translate.currentLang?.includes('es')){
      this.isEnglishText = false;
    }
    this.uniqueId =  _.uniqueId('onoffswitch_');
    
   }

  ngOnInit(): void {
    if(this.customText){
      this.status=this.switchInput;
      this.currentText=this.onText;
    }
    else
   { 
     this.currentText = this.offText;
    }
  }

  ngOnChanges(changes) {
    this.switchInput = changes.switchInput.currentValue;
  }


  valueChange(event:boolean){
    this.currentText = this.offText;
    if(event){
      this.currentText = this.onText;
    }
    this.status = event;
    this.switchChange.emit(event); 
  }

  getTranslation(value){
    return value ? this.translate.instant(`common.${value}`) : value;
  }
}
